<template lang="pug">
.padding
    .row
        .col-md-4
            .m-b-sm
                h5.m-b-0.p-t-sm._300 Products

        .col-md-8
            .row
                .col-md-4.pull-right.m-y-sm
                    select.form-control.c-select(
                        @change="applyFilter()",
                        v-model="inventory_type"
                    )
                        option(:value="null") Filter Stock type
                        option(value="1") Component
                        option(value="0") End Product

                .col-md-4.pull-right.m-y-sm.p-r-0
                    tags-selector(@select="onSelectTags")

        .col-md-12
            .box
                v-server-table(
                    :url="api",
                    :name="tableName",
                    ref="datatable",
                    :columns="columns",
                    :options="options"
                )
                    template(slot="provider_id", slot-scope="props")
                        span.text-muted(v-if="props.row.provider_id === null")
                            i N/A
                        span(v-if="props.row.provider_id == 1") Slurp!

        create-form(ref="productCreate")
</template>

<script>
import createForm from './product-create.vue';
import productMixin from './product-mixins';

export default {
    components: {
        createForm,
    },

    mixins: [productMixin],

    data() {
        var that = this;

        return {
            tag: null,
            inventory_type: null,
            tableName: 'VUETABLE_PRODUCT',
            columns: [
                'name',
                'code',
                'variants',
                'tags',
                'provider_id',
                'inventory_type',
            ],
            options: {
                customFilters: ['inventory_type', 'tag'],
                initFilters: { inventory_type: null, tags: [] },
                headings: {
                    provider_id: 'Provider',
                },
                permission: {
                    create: () => this.permission.SAVE_PRODUCT,
                    delete: () => this.permission.DELETE_PRODUCT,
                },
                checkbox: {
                    disableKey: 'has_variant_as_component',
                    delete_title: 'Delete Product',
                    api_delete: Laroute.route('products.delete'),
                },
                csv_url: Laroute.route('products.export', { type: 'csv' }),
                pdf_url: Laroute.route('products.export', { type: 'pdf' }),
                xls_url: Laroute.route('products.export', { type: 'xlsx' }),
                create_btn: {
                    title: 'Create Product',
                    action: () => {
                        that.showForm(null);
                    },
                },
                sortable: ['name', 'code'],
                templates: {
                    variants(h, row) {
                        return require('./columns/variants.jsx')(h, row);
                    },
                    tags(h, row) {
                        return require('./columns/tags.jsx')(h, row);
                    },
                    inventory_type(h, row) {
                        return require('./columns/inventory_type.jsx')(h, row);
                    },
                },
                rowClassCallback: that.getRowClass,
                rowClickCallback: that.showForm,
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('products.list');
        },

        canUpdate() {
            return this.can(this.permission.SAVE_PRODUCT);
        },
    },

    watch: {
        tag() {
            this.applyFilter();
        },
    },

    methods: {
        showForm(row) {
            if (row == null) {
                this.showCreateForm();
            } else {
                if (!this.canUpdate) return;

                this.$router.push(`/${row.id}`);
            }
        },

        refresh() {
            this.$refs.datatable.getData();
        },

        getRowClass() {
            if (this.canUpdate) {
                return 'pointer';
            }
        },

        onSelectTags(tag) {
            this.tag = tag;
        },

        applyFilter() {
            this.$refs.datatable.customQueries.tag = this.tag;
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'inventory_type',
                value: this.inventory_type,
            });
        },

        showCreateForm() {
            this.$refs.productCreate.$emit('show');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/product/product-list.vue